export default __webpack_public_path__ + "static/media/storage-tank.1e9b4ffe.svg";